import { SET_BLOGS_STATE } from '../constants/redux_types'

export const setBlogsStateAction = payload => {
  return {
    type: SET_BLOGS_STATE,
    payload: payload
  }
}
